import header from "./working-on-cad-system.jpg";
import section1 from "./cad-system-on-pc.jpg";
import section2 from "./monitor-mit-bauzeichnung.jpg";
import section3 from "./cad-system-on-laptop.webp";

export { header, section1, section2, section3 };
